import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Row from '../Row';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setCurrentUserSuite } from '../../store/actions/userSuites';
import { clearOrderDetails, clearOrders, onFetchOnboardingOrders } from '../../store/actions/HomeOwnerOnboardingDashboard';
import { PATHS } from '../../common/constants';
import "./SuiteInfoHeader.scss";
import Col from '../Col';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';
const SuiteInfoHeader = () => {
    const theme = localStorage.getItem('theme');
    const [showSuiteDrop, setShowSuiteDrop] = useState(false)
    const userSuiteList = useSelector(state => state?.userSuites?.userSuiteList || [])
    const currentUserSuite = useSelector(state => state?.userSuites?.selectedUserSuite || {})
    const onboardingData = useSelector(state => state?.onboardingData || [])
    const data = useSelector(state => state?.auth?.propertyManagerDetails || {})
    const myHomeCheck = (currentUserSuite.status === 'Occupied' || (currentUserSuite.status !== 'Occupied' && onboardingData.orders && onboardingData.orders.length === 0))
    const collapseSideBar = useSelector(state => state?.collapseSideBar || false);
    const user = useSelector(state => state.auth?.user || {})
    const dispatch = useDispatch();
    const history = useHistory();

    const renderDropIcon = () => {
        return (
          <i
            className={`suiteInfoHeader__icon fa-chevron-${
              showSuiteDrop ? "up" : "down"
              } fas`}
            style={{ marginRight: "24px" }}
          />
        );
      };

     const handleOnSuiteSelect = (suiteData) => () => {
        onCurrentSuiteChange(suiteData);
        setShowSuiteDrop(false);
      };
      const onCurrentSuiteChange = async (data) => {
            dispatch(clearOrders())
            dispatch(clearOrderDetails())
            dispatch(setCurrentUserSuite(data));
            // if(data && data.status !== 'Occupied') {            
                dispatch(onFetchOnboardingOrders(data.propertyId, data.id, user.id))
            // }
            if(window.location.pathname !== '/app/dashboard'){
              history.push('/app/dashboard');
            }
    }
     const handleSuiteClick = () => {
        setShowSuiteDrop(!showSuiteDrop);
      };
      const renderSuiteDropDown = () => {
        const { id: currentSuiteId } = currentUserSuite;
        if (showSuiteDrop) {
          return (
            <ul className="suite_title_drop">
              {userSuiteList.map((suite) => {
                const { id, propertyName, warrantyAddress, number } = suite;
                return (
                <li
                className={`suite_tile__ suite_tile__${id === currentSuiteId ? "selected" : ""}`}
                onClick={handleOnSuiteSelect(suite)}
              >
                <div className="proptery_name">{propertyName}</div>
                <snap>{number}</snap> , <span>{warrantyAddress}</span>
              </li>
                );
              })}
            </ul>
          );
        }
      };

    return (
            <div 
            className={
              classNames(
                "suiteInfoHeader",
                {
                  "navigation__anchor--label--collapse":collapseSideBar
                }
              )
            }
            >
              <Row id="main_header">
                <Col md={3} xs={4} id='myhome_header'>
               <Link
               to={{
                 pathname: PATHS.SUITES_VIEW.replace(
                   ":id",
                   currentUserSuite.propertyId + "&" + currentUserSuite.id
                 ),
                 state: {
                   suite: { id: currentUserSuite.id },
                   property: { id: currentUserSuite.propertyId },
                   activeTab: 0,
                   from: "Dashboard",
                 },
               }}
             >
               {userSuiteList && userSuiteList.length > 0 ? 
                // (myHomeCheck || theme !== "Shape") && 
                <div className="suiteInfoHeader__MessageButton">My Home</div> : null}
              </Link>
              </Col>
                 <Col md={9} xs={8} id='myhome_header'>
            <div className="suite_tile_wrapper" >
              <div
                className={userSuiteList && userSuiteList.length > 1 ? 'suiteInfoHeader__profile suite_tite' :
                  'suiteInfoHeader__profile'}
                onClick={() => handleSuiteClick()}
              >
                <div>
                  <div className="suiteInfoHeader__profileContent">
                    <Row>
                    <Col md={9} xs={9}>
                    <Row>
                      <label className="suiteInfoHeader__property">
                        {currentUserSuite.propertyName}
                      </label>
                    </Row>
                    <Row>
                      <label className="suiteInfoHeader__property">
                        {currentUserSuite.number}
                      </label>
                    </Row>
                    </Col>
                    <Col md={3} xs={3}>
                    {userSuiteList && userSuiteList.length > 1 &&
                  renderDropIcon()}</Col>
                  </Row>
                    {/* <Row>
                      <label className="suiteInfoHeader__role">
                        {currentUserSuite.warrantyAddress}
                      </label>
                    </Row> */}
                  </div>
                </div>
               
              </div>
              {renderSuiteDropDown()}
            </div>
            </Col>
            </Row>
            </div> 
    )
}

export default SuiteInfoHeader;